import EStyleSheet from 'react-native-extended-stylesheet';

const styles = EStyleSheet.create({
	scrollInner: {
		flexGrow: 1,
	},
});

export default styles;
